module.exports = __webpack_public_path__ + "media/images/file-5e419974.svg";